module.exports = __webpack_public_path__ + "img/g2-crowd.0e7b3b33.png";